import { find } from 'ramda';

export const counties = [
  { text: '', value: ''},
  { text: 'Harju', value: 'Harju'},
  { text: 'Hiiu', value: 'Hiiu'},
  { text: 'Ida-Viru', value: 'Ida-Viru'},
  { text: 'Järva', value: 'Järva'},
  { text: 'Jõgeva', value: 'Jõgeva'},
  { text: 'Lääne', value: 'Lääne'},
  { text: 'Lääne-Viru', value: 'Lääne-Viru'},
  { text: 'Saare', value: 'Saare'},
  { text: 'Tartu', value: 'Tartu'},
  { text: 'Valga', value: 'Valga'},
  { text: 'Viljandi', value: 'Viljandi'},
  { text: 'Pärnu', value: 'Pärnu'},
  { text: 'Põlva', value: 'Põlva'},
  { text: 'Rapla', value: 'Rapla'},
  { text: 'Võru', value: 'Võru'}
];


export const getCountyByCode = (countyCode) =>
    countyCode ? find(c => c.value === countyCode, counties).text : null;



// WEBPACK FOOTER //
// ./src/common/utils/data/counties.js